var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogouticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Logout_Icon_-_Default_-_White_icon_with_transparent_background"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logout_Icon_-_Default_-_White_icon_with_transparent_background",
    "data-name": "Logout Icon - Default - White icon with transparent background",
    clipPath: "url(#clip-Logout_Icon_-_Default_-_White_icon_with_transparent_background)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "login-24px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2981",
    "data-name": "Group 2981"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_682",
    "data-name": "Rectangle 682",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2982",
    "data-name": "Group 2982",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_684",
    "data-name": "Rectangle 684",
    width: 24,
    height: 24,
    transform: "translate(-2 -3)",
    fill: "#586981",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "login-24px-2",
    "data-name": "login-24px",
    transform: "translate(-2 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2981-2",
    "data-name": "Group 2981"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_682-2",
    "data-name": "Rectangle 682",
    width: 24,
    height: 24,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3001",
    "data-name": "Group 3001"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3651",
    "data-name": "Path 3651",
    d: "M4,19h8v2H4a2.006,2.006,0,0,1-2-2V5A2.006,2.006,0,0,1,4,3h8V5H4Z",
    transform: "translate(-2 -3)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2982-2",
    "data-name": "Group 2982",
    transform: "translate(6 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3651-2",
    "data-name": "Path 3651",
    d: "M17,7,15.6,8.4,18.2,11H8v2H18.2l-2.6,2.6L17,17l5-5Z",
    transform: "translate(-8 -7)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogouticon);
export default __webpack_public_path__ + "static/media/logouticon.7b77cd4606bd034520241f9c51b30178.svg";
export { ForwardRef as ReactComponent };